import { DeepFrozenObject } from './deep-object-freeze.types';

export function isKeyOfObject<T extends object>(
  key: string | number | symbol,
  obj: T
): key is keyof T {
  return key in obj;
}

export const deepObjectFreeze = <T>(
  obj: T,
  freezeParent = true
): DeepFrozenObject<T> => {
  if (freezeParent) Object.freeze(obj);

  Object.getOwnPropertyNames(obj).forEach(function (property) {
    if (
      Object.prototype.hasOwnProperty.call(obj as any, property) &&
      (obj as any)[property] !== null &&
      (typeof (obj as any)[property] === 'object' ||
        typeof (obj as any)[property] === 'function')
    ) {
      if (Object.isFrozen((obj as any)[property])) {
        deepObjectFreeze((obj as any)[property], false);
      } else {
        deepObjectFreeze((obj as any)[property], true);
      }
    }
  });

  return obj as DeepFrozenObject<T>;
};
